<template>
  <div class="pageWrapper_home">
    <div class="fan_massage">
      <div class="top_header">
        <div class="back-icon" @click="goBack()">
          <i class="material-icons">arrow_back</i>
        </div>
        <div class="container">
          <Header update_profile_txt=" Update Your Profile" icon_txt="arrow_forward" />
          <div class="title_historydetail" v-if="name">
            <h1>{{name}}</h1>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="middlePannel_acceptedMessage middlePannel_historydetails">
          <div class="post-img" @click="playVideo">
            <img
              :src="this.fanDetails.thumbnail"
              v-if="this.fanDetails.thumbnail"
            />
            <img src="../assets/images/video_overlay.png" v-else />
          </div>
          <ul>
            <li>
              <span class="users-profile">
                <img
                  :src="this.fanDetails.celeb_profile_pic"
                  v-if="this.fanDetails.celeb_profile_pic"
                />
                <img src="../assets/images/user_images.png" v-else />
                <span class="star_user_img">
                  <img
                    :src="this.fanDetails.user_profile_pic"
                    v-if="this.fanDetails.user_profile_pic"
                  />
                  <img src="../assets/images/user_images.png" v-else />
                </span>
              </span>
              <div class="details_profile">
                <span class="users-video-fanhistory">
                  {{$t('createdVideofor')}}
                  <b>{{this.fanDetails.video_for}}</b> by
                  <b>{{this.fanDetails.video_to}}</b>
                </span>
                <div class="likes-cmt-fanhistory">
                  <i class="material-icons">thumb_up</i>
                  {{this.fanDetails.likes ? this.fanDetails.likes.length : '0'}} {{$t('likes')}}
                  <i
                    class="material-icons"
                  >comment</i>
                  {{this.fanDetails.comments ? this.fanDetails.comments.length : '0'}} {{$t('Comments')}}
                </div>
              </div>
            </li>
          </ul>
          <div class="comments">
            <p>{{$t('Comments')}}</p>
            <span
              class="cmnt-length"
              v-if="this.fanDetails.comments"
            >{{this.fanDetails.comments ? this.fanDetails.comments.length : null }} {{$t('madeComments')}}</span>
            <ul>
              <li
                v-for="comments in this.fanDetails.comments"
                :key="comments.comment_time"
              >
                <span class="users-profile-img">
                  <img :src="comments.profile_pic" v-if="comments.profile_pic" />
                  <img src="../assets/images/user_images.png" v-else />
                </span>
                <div class="cmt-details">
                  <span class="user-name">
                    {{comments.from_user}}
                    <strong>{{(comments.comment_time)}}</strong>
                  </span>
                  <span class="user-cmt">{{comments.comment}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="likes">
            <p>{{$t('likes')}}</p>
            <span
              class="likes-length"
              v-if="this.fanDetails.likes"
            >{{this.fanDetails.likes ? this.fanDetails.likes.length : null}} {{$t('PeopleHaveliked')}}</span>
            <ul>
              <li v-for="likes in this.fanDetails.likes" :key="likes.like_time">
                <span class="likes-users-img">
                  <img :src="likes.profile_pic" v-if="likes.profile_pic" />
                  <img src="../assets/images/user_images.png" v-else />
                </span>
                <div class="likes-username-details">
                  <span class="likes-username">
                    {{likes.from_user}}
                    <strong>{{(likes.like_time)}}</strong>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <VideoModel ref="vdoRefs" :v_link="video_url" v-if="isVideo" />
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import Header from "../components/Header";
import Btn from "../components/Btn";
import Footer from "../components/Footer";
import VideoModel from "../components/VideoModel";
import { toaster } from "../utils/helper";
import VueCookie from "vue-cookie";

export default {
  name: "FanHistoryDetails",
  components: {
    Footer,
    Btn,
    Header,
    VideoModel
  },
  data() {
    return {
      isVideo: false,
      video_url: null,
      loading: false,
      name: JSON.parse(VueCookie.get("user"))
        ? JSON.parse(VueCookie.get("user")).name
        : "",
      fanDetails: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    playVideo() {
      let url = window.location.href.split("?")[0].split("/")
      const mediaId = window.location.href.split("?")[0].split("/")[url.length-1]
      this.loading = !this.loading;
      this.$store
        .dispatch({
          type: "playVideo",
          payload: mediaId
        })
        .then(data => {
          this.loading = !this.loading;
          this.video_url = data.data.media_details.video;
          this.isVideo = true;
          document.body.classList.add("videoBody");
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(
            this,
            this.$t("somethingWentwrong"),
            "top-center",
            2000
          );
        });
    }
  }, 
 created(){
   this.fanDetails = JSON.parse(sessionStorage.getItem("fan_detail"))
 console.log("$$$$$$$$$$$$",this.fanDetails)

 }
};
</script>
